import React, { useMemo, useEffect } from 'react';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Take from 'containers/Administrator/Home/Active/Take';

const Takes = () => {
	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[student, exam.subject]',
		state: 'active',
		orderBy: 'startedAt',
		rangeStart: 0,
		rangeEnd: 4
	}), []);

	// Store requested takes
	const [[collection, progress], collect] = useCollect('takes', parameters);

	// Collect exams on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div className="space-y-4">
			<div className="flex items-center space-x-2">
				<Icon
					icon="assignment"
					className="text-amber-500 text-xl"
				/>

				<Title
					title={`Aktīvie pārbaudes darbi (${collection?.total || 0})`}
					className="text-xl flex-1"
				/>
			</div>

			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Show nothing found */}
			<Nothing visible={!collection?.results?.length && !progress} />

			{/* Show collection if results are collected */}
			<Show if={collection?.results?.length}>
				<div className="space-y-2">
					{collection?.results?.map(take =>
						<Take key={take.id} take={take} />
					)}
				</div>
			</Show>
		</div>
	);
};

export default Takes;